import {Component} from "@angular/core";
import {HelperService} from "../../../services/helperService";


@Component({
  selector: "tig-footer",
  templateUrl: "footer.template.html"
})
export class FooterComponent
{


	/**
	 * Attribute
	 */
	STR_company: string;


	/**
	 * Function > constructor
	 * @param {HelperService} OBJ_helper_service
	 */
	constructor(private OBJ_helper_service: HelperService)
	{

        // get company string
        let OBJ_config = OBJ_helper_service.getFromLocalstorage('config');
        this.STR_company = OBJ_config.company;

	} // end function constructor


	/**
	 * Function > openExternalUrl
	 * @param {string} STR_url
	 * @param {string} STR_target
	 */
	openExternalUrl(STR_url: string, STR_target = '_blank'): void
	{
		window.open(STR_url, STR_target);
	} // end function openExternalUrl


} // end class FooterComponent
